import swal from 'sweetalert';

/* USE THIS FUNCTION WHEN YOU WANT TO SHOW SWAL ALERT MESSAGE BASED ON STATUS CODE FROM RESPONSE */
export const getStatusAlert = ({status, message, reCallGrid, buttonText}) => {
    switch (status) {
        case 1:
            if (reCallGrid !== undefined) {
                reCallGrid()
            }
            return swal(message, { icon: "success"});
        case 3:
            return swal(message, { icon: "warning", button: "Ok" }).then(() => {
                if (reCallGrid !== undefined) {
                    reCallGrid()
                }
            })
        case 0:
        case 202:
        case 204:
        case 409:
            return swal(message, { icon: "warning"});
        default:
            return swal({title: message, icon: "error", button: buttonText})
    }
};

const getTotalCount = (column, records, setTotalQuanties) => {
    const totalObj = {}
    const totalQty = records.reduce((acc, currentItem) => acc + Number(currentItem[`${column.dataField}`]), 0);
    totalObj["name"] = column.text.toUpperCase();
    totalObj["count"] = totalQty
    setTotalQuanties((prevState => {
        if(prevState?.length >= 1){
            for(let state of prevState){
                if(state.name === totalObj.name){
                    break;
                }else{
                    return [...prevState, totalObj]
                }
            }
        }
        return [totalObj]
    }))
}
  
export const getReportTotalQuanties = (columns, records,setTotalQuanties) => {
    if(records?.length === 0){
        setTotalQuanties([]);
    }
    else if (records?.length > 0) {
        columns.forEach(column => {
            if (column?.gridTotal) {
                getTotalCount(column, records,setTotalQuanties)
            }
        })
    }
}